import { getStateWithOnlyOneLevel } from '../../utilities/StateSelectorHelper';

function getState(state) {
  return getStateWithOnlyOneLevel(state, 'audioGenerationQueue');
}

export const getAudioGenerationQueueData = (state) =>
  getState(state).get('audioGenerationQueueData');
export const getAbbreviationsQueueData = (state) =>
  getState(state).get('abbreviationsQueueData');
